export const MandateStatus = {
  NotInitiated: 1,
  Initiated: 2,
  Partial: 3,
  Successful: 4,
  Rejected: 5,
  DigioUpiMandateSuccessful: 11,
  DigioEmandateSuccessful: 14,
  DigioAadhaarMandate: 15,
  DigioUpiMandate: 16,
  PhonePeUpiMandate: 22,
};

export const MandateStatusArray = [
  "",
  "Not Initiated",
  "Initiated",
  "Partial",
  "Successful",
  "Rejected",
];

export const AgreementStatus = {
  NotInitiated: 1,
  Initiated: 2,
  Signed: 3,
  Pending: 4,
  InvalidSignature: 5,
  Regenerate: 6,
  PendingCoapplicant: 7,
  Skip:10,
  Manual:9
};

export const SelfieStatus = {
  NotInitiated: 1,
  Initiated: 2,
  Successful: 3,
  Failed: 4,
  Mismatch: 5,
};

export const BankVerificationStatus = {
  NotInitiated: 1,
  Successful: 2,
  Failed: 3,
};

export const DigilockerStatus = {
  NotInitiated: 1,
  Initiated: 2,
  Successful: 3,
  Failed: 4,
  Alert: 5,
  Skip:6
};

export const FacematchSource = {
  Digilocker: "Digilocker",
  Ckyc: "Ckyc",
};

export const AgreementStatusArray = [
  "",
  "Not Initiated",
  "Initiated",
  "Signed",
  "Pending",
];

export const SelfieStatusArray = [
  "",
  "Not Initiated",
  "Initiated",
  "Successful",
  "Failed",
];
